import { ListItem } from '../ListItem';

export class PatientProcedureDayType {

    static List(): ListItem[] {

        let list: ListItem[] = [
            { "id": 1, "name": "pre-procedure" },
            { "id": 2, "name": "post-procedure" },
            { "id": 3, "name": "feedback" },
            { "id": 4, "name": "action" },
        ];

        return list;
    }

    static Name(id: number): string {

        let rtn: string = "";

        PatientProcedureDayType.List().forEach(obj => {

            if (obj.id == id) {
                rtn = obj.name;
            }

        });

        return rtn;

    }

    static Value(name: string): number {

        let rtn: number = 0;

        PatientProcedureDayType.List().forEach(obj => {

            if (obj.name == name) {
                rtn = obj.id;
            }

        });

        return rtn;

    }

}